
!function ($) {

	function TableToggle($container) {
		this.init($container);
	}

	TableToggle.prototype = {

		row: 0,
		maxed: false,

		_createColumn: function () {
			const that = this;
			if (this.$clone) {
				this.$clone.remove();
			}
			if (this.$container.find("div.screener-tab").length > 0 && this.$container.find("div.screener-tab:visible").find("table").length > 0) {
			    this.$table = this.$container.find("div.screener-tab:visible").find("table").eq(0);
			    this.$wrapper = this.$container.find("div.screener-tab:visible").find('.table-toggle-container');
			    this.$controls = this.$container.find("div.screener-tab:visible").find('.table-toggle-controls');
			}
			else {
			    this.$table = this.$container.find('table');
			}
			
			this.backupTable();
			
			this.$clone = this.$table.clone();

            this.$clone.addClass('table-floater');

            this.$clone.attr('aria-hidden', true);

            this.$clone.removeAttr('tabindex');

            this.$clone.find('td').each(function () {
                $(this).removeAttr('tabindex');
            });

            this.$clone.find('a').each(function () {
                $(this).attr('tabindex', '-1');
			});

			const ariaLabel = this.$clone.find('.column-symbol-name').attr('aria-label');

			this.$clone.find("[data-sqlname='WFMFMDESSymbol'] a").replaceWith(function () {
				return $("<span class='column-header' style'cursor: pointer'>").append($(this).contents()).attr('aria-label', ariaLabel);
			});

			this.$table.find('a.popover-link-etf-leverage').focus(function () {
				const symbol = $(this).siblings('a.link-underline').data('symbol');
				that.$clone.find('a.link-underline[data-symbol="' + symbol + '"]').siblings('a.popover-link-etf-leverage').removeClass('blur').addClass('focus');
			}).blur(function () {
				const symbol = $(this).siblings('a.link-underline').data('symbol');
				that.$clone.find('a.link-underline[data-symbol="' + symbol + '"]').siblings('a.popover-link-etf-leverage').removeClass('focus').addClass('blur');
			});

			this.$clone.width(this.$table.find('thead th:first').outerWidth());

			this.$clone.find('thead tr').each(function () {
				$(this).find('th:not(:first)').remove();
			});

			this.$clone.find('tbody tr').each(function () {
			    $(this).find('td:not(:first)').remove();
			});

			this.$clone.find('thead th').addClass('mk-advanced-screener-cell');

			this.$table.css({ left: 0 });
			this.$clone.css({ left: 0 });

			this.$wrapper.append(this.$clone);
		},

		_createOverflow: function () {

			if (this.$overflow) {
				this.$overflow.remove();
			}
			this.$overflow = $('<div class="table-toggle-overflow" />');
			this.$overflow.appendTo(this.$wrapper);
		},

		_rowcount: function () {
			return this.$table.find('thead th').length - 1;
		},

		_adjust: function (l) {

			var w = this.$wrapper.width(),
				mw = this.$table.width();

			if (l + w > mw) {
				this.maxed = true;
				return mw - w;
			}
			this.maxed = false;
			return l;
		},

		_step: function (step) {

			if (step == -1 && this.row == 1) return;
			if (step == 1 && (this.row == this._rowcount() || this.maxed)) return;

			var $cols = this.$table.find('thead th'),
				r = this.row + step,
				w = 0;

			if (r > 1) {

				$cols.each(function (i) {

					if (i == 0) return;
					if (i == 1) w -= 1;	//border
					if (i < r) {
						w += $(this).outerWidth();
					}
				});
			}

			this.row = r;

			w = this._adjust(w);

			var l = parseInt(this.$table.css('left')) || 0,
				z = w * -1;

			if (z == l) {
				return this._step(step);
			}

			this.$overflow[this.maxed ? 'hide' : 'show']();
			this.$clone.toggleClass('overflow', this.row > 1);
			this.$table.css('left', w * -1);
		},

		_getPageStep: function (reverse) {

			var $rows = this.$table.find('thead th'),
				width = this.$wrapper.width(),
				steps = 0, w = 0;

			if (reverse === true) {
				for (var i = this.row; i > 0; i--) {
					if (w <= width) {
						w += $($rows[i]).outerWidth();
						steps++;
					}
				}
				return (steps - 1) * -1;
			}

			for (var i = 0, l = $rows.length; i < l; i++) {
				if (i >= this.row) {
					w += $($rows[i]).outerWidth();
					if (w <= width) steps++;
				}
			}
			return steps - 1;
		},

		_page: function (dir) {

			if (dir == -2 && this.row == 1) return;
			if (dir == 2 && (this.row == this._rowcount() || this.maxed)) return;

			var steps = this._getPageStep(dir == -2);

			this.row += steps;
			this._step(0);
		},

		init: function ($container) {
		    this.$container = $($container);
		    if (this.$container.find("div.screener-tab").length > 1 && this.$container.find("div.screener-tab:visible").find("table").length > 0) {
		        this.$wrapper =  this.$container.find("div.screener-tab:visible").find('.table-toggle-container');
		        this.$controls =  this.$container.find("div.screener-tab:visible").find('.table-toggle-controls');
		    }
		    else {
		        this.$wrapper = this.$container.find('.table-toggle-container');
		        this.$controls = this.$container.find('.table-toggle-controls');
		    }

			this.row = 1;

			this.build();
			this.bind();
		},

		build: function () {
			this._createColumn();
			this._createOverflow();

			if (this.$table.width() > this.$wrapper.width()) {
				this.$overflow.show();
				this.$controls.show();
			}

			else {
				this.$controls.hide();
			}

			this.restoreCloneTable();
		},

		backupTable: function() {
			
			/* 
				1st Step: Back up ids and hrefs of the real table.
				Detail: 
				Id and href attribs need to be backed up in the real table
				for being removed latter and do not lose them.
			*/

			//	The next lines back up href attrib in new attrib data-href in the real table.
			this.$table.find('a.symbol-link').each(function (index, element) {
				if ($(this).attr('href')) {
					$(this).attr('data-href', $(this).attr('href'));
				}
			});

			/*	
				2nd Step: Remove all backed up ids and hrefs of the real table. 
				Detail: 
				Href attribs need to be removed in the real table for letting the user 
				agent to define the main navigation to the cloned table by default. 
				Id attribs need to be removed in the cloned table for avoiding axe issues with
				the ids of the cloned table.
			*/
			
			// The next lines remove href attribs in the real table, this will solve tab navigation issues.
			this.$table.find('a.popover-link-etf-leverage').removeAttr('href');
            this.$table.find('a.symbol-link').removeAttr('href');

            // Adds a href attribute to the anchor tag so the element is focusable
            this.$table.find('a.symbol-link').attr('href', 'javascript:void(0)');

			// The next lines remove tabindex attribs in the real and cloned table, this will avoid tab navigation issues.
			this.$table.find('.symbol-link').removeAttr('tabindex');
			this.$table.find('.popover-link-etf-leverage').attr('tabindex', '0'); 
		},

		restoreCloneTable: function() {
						
			/*	
				3rd Step: Restore all ids and hrefs in the cloned table. 
				Detail: 
				All backed up attribs (id and href) from real table will be restored in the cloned table, 
				this will disable tab navigation and popover functionality of the real table and 
				let the cloned table to handle tab navigation and popover functionality.
			*/		
			
			//	The next lines restore href attrib in cloned table from data-href attrib of the real table.
			this.$clone.find('.symbol-link').each(function (index, element) {
				if ($(this).attr('data-href')) {
					$(this).attr('href', $(this).attr('data-href'));
				}
			});
			
			this.$clone.find('a.popover-link-etf-leverage').attr('href', 'javascript:void(0)');
		},

		update: function (row) {
			this.row = 1;
			this.maxed = false;
			this.build();

			if (row !== undefined) {
				row = parseInt(row, 10) || 1;

				if (row > 1) {
					for (var i = 1; i < row; i++) {
						this.move(1);
					}
				}
			}
		},

		bind: function () {

			var me = this;

			this.$controls.on('click.table-toggle touchstart', 'a', function (e) {
				e.preventDefault();
				me.move($(this).attr('data-moveto'));
			});

			var t;

			$(window).on('resize.mk-table-toggle', function () {
				if (t) {
					clearTimeout(t);
					t = null;
				}
				t = setTimeout(function () { me.update(); }, 500);
			});
		},

		move: function (dir) {

			var d = parseInt(dir) || 0;

			switch (d) {

				case -2:
				case 2:
					this._page(d);
					break;

				case -1:
				case 1:
					this._step(d);
					break;
			}

			this.refreshControls()

		},

		refreshControls: function () {
						// TODO : super basic implementation for [WF-1840]
			//	doesn't work exactly right.  It takes an extra click to get the desired behavior
			this.$controls.find('.previous').removeClass('disabled').attr('aria-disabled', 'false');
			this.$controls.find('.next').removeClass('disabled').attr('aria-disabled', 'false');

			if (this.row == 1) {

				this.$controls.find('.previous').addClass('disabled').attr('aria-disabled', 'true');

				return;
			}

			if (this.row == this._rowcount() || this.maxed) {

				this.$controls.find('.next').addClass('disabled').attr('aria-disabled', 'true');

				return;
			}
		},

		resizedExternally: function() {
            var targetCol = this.row;
			
			this.$table.css({ left: 0 });
			this.$clone.css({ left: 0 });
			this.row = 1;
			this.maxed = false;

			if (this.row < targetCol) {
				while (this.row < targetCol && !this.maxed) {
					console.log('>>> move +1', targetCol, this.row);
					this.move(1);				
					console.log('>>> move +1 this.row', this.row);
				}			
			}
			if (this.row > targetCol && !this.maxed) {
				while (this.row > targetCol && !this.maxed) {
					console.log('>>> move -1', targetCol, this.row);
					this.move(-1);				
					console.log('>>> move -1 targetCol', this.row);
				}			
			}
			
			this.refreshControls();
		}
	};

	$.fn.mktabletoggle = function () {

		return this.each(function () {
			var $el = $(this);

			$el.data('mk-table-toggle',
				$el.data('mk-table-toggle') || new TableToggle(this));
		});
	};

	$(function () {
		$('.mk-table-toggle').mktabletoggle();
	});

}(window.jQuery);
